@if (isAvatarItem) {
  <ng-container *ngTemplateOutlet="avatarTemplate" />
} @else {
  @if (isNavGroupItem) {
    <div class="item-container">
      <a [class.selected]="selected" [routerLink]="$any(item).url" (click)="onGroup()">
        <mat-icon class="sidebar-item-icon" [svgIcon]="item.icon" />
        <div class="sidebar-item-text">{{ item.display }}</div>
      </a>
    </div>
  } @else {
    <div class="item-container">
      <a [class.selected]="selected" [routerLink]="$any(item).url" (click)="onItem()">
        <mat-icon class="sidebar-item-icon" [svgIcon]="item.icon" />
        <div class="sidebar-item-text">{{ item.display }}</div>
      </a>
      @if ($any(item).url === '/alerts') {
        <alert-count-display />
      }
    </div>
  }
}

<ng-template #avatarTemplate>
  <div class="item-container">
    <a (click)="onItem()">
      @if (user) {
        <oph-avatar [user]="user" [size]="29" />
      } @else {
        <mat-icon class="sidebar-item-icon" [svgIcon]="'user'" />
      }
      <div class="sidebar-item-text">{{ item.display }}</div>
    </a>
  </div>
</ng-template>
